import { BaseCommand } from './BaseCommand';
import { MapCommandType } from '../types';
import { ILineConfig } from '../../types';
import { LineManager } from '../../managers/LineManager';

export class AddLineCommand extends BaseCommand {
  private lineManager: LineManager;
  private line: ILineConfig;

  constructor(lineManager: LineManager, line: ILineConfig) {
    super(MapCommandType.ADD_LINE, `Add line with ${line.coordinates.length} points`);
    this.lineManager = lineManager;
    this.line = line;
  }

  execute(): void {
    this.lineManager.addLine(this.line);
  }

  undo(): void {
    this.lineManager.removeLine(this.line.id);
  }

  canExecute(): boolean {
    return !this.lineManager.hasLine(this.line.id);
  }

  canUndo(): boolean {
    return this.lineManager.hasLine(this.line.id);
  }
}

export class RemoveLineCommand extends BaseCommand {
  private lineManager: LineManager;
  private line: ILineConfig;

  constructor(lineManager: LineManager, line: ILineConfig) {
    super(MapCommandType.REMOVE_LINE, `Remove line ${line.id}`);
    this.lineManager = lineManager;
    this.line = line;
  }

  execute(): void {
    this.lineManager.removeLine(this.line.id);
  }

  undo(): void {
    this.lineManager.addLine(this.line);
  }

  canExecute(): boolean {
    return this.lineManager.hasLine(this.line.id);
  }

  canUndo(): boolean {
    return !this.lineManager.hasLine(this.line.id);
  }
}

export class UpdateLineCommand extends BaseCommand {
  private lineManager: LineManager;
  private newLine: ILineConfig;
  private previousLine: ILineConfig;

  constructor(lineManager: LineManager, newLine: ILineConfig, previousLine: ILineConfig) {
    super(MapCommandType.UPDATE_LINE, `Update line ${newLine.id}`);
    this.lineManager = lineManager;
    this.newLine = newLine;
    this.previousLine = previousLine;
  }

  execute(): void {
    this.lineManager.updateLine(this.newLine);
  }

  undo(): void {
    this.lineManager.updateLine(this.previousLine);
  }

  canExecute(): boolean {
    return this.lineManager.hasLine(this.newLine.id);
  }

  canUndo(): boolean {
    return this.lineManager.hasLine(this.previousLine.id);
  }
}
